export default ({ request }) => ({

  customerRecommendListApi (data = {}) {
    return request({
      url: '/digitalCenter/shopCustomerRecommend/list',
      method: 'post',
      data
    })
  }
})
